const PublishedCell = ({ value }: any) => (
  <span className="published-cell-container">
    {value ? <span className="is-published" /> : <span className="not-published" />}
  </span>
);

export default PublishedCell;
